<template>
  <div class="AddpersonTag addCommon" style="height: 100%">
    <div class="return">
      <i class="el-icon-back" @click="goReturn">{{$t('LanguageLib.Return')}}</i>
      <span class="border"></span>
      <span class="title">{{ titleType }}</span>
    </div>
    <div class="content">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="0px" class="ruleForm">
        <el-button @click="submit('ruleForm')" type="primary" class="searchBtn" style="margin-left: 0;" :loading="loadingSave">{{$t('LanguageLib.SAVE')}}</el-button>
        <p class="drawerText">{{$t('LanguageLib.SERIAL_NUMBER')}}</p>
        <el-form-item>
          <el-input
            oninput="this.value=this.value.replace(/[^\d]/g,'');"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            :maxlength="9"
            v-model="ruleForm.SortNo"
          >
          </el-input>
        </el-form-item>
        <p class="drawerText"><span class="colorRed">*</span>&nbsp;{{$t('LanguageLib.LABEL_NAME')}}</p>
        <el-form-item prop="TagName">
          <el-input
            maxlength="50"
            @keyup.native="btKeyUp"
            style="width: 320px;"
            :placeholder="$t('LanguageLib.PleaseEnter')"
            v-model="ruleForm.TagName"
          >
          </el-input>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import basicdataApi from '../../api/basicdata'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
export default {
  props: ['currentPage', 'pageSize', 'parentId', 'searchText', 'sort', 'sortOrder', 'checkedSelectData', 'searchDescContent', 'searchOrgName', 'orgName', 'type', 'sortNumber', 'orgTypeid', 'remark'],
  data () {
    var checkTagName = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t('LanguageLib.LABEL_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
      } else {
        if (this.$commonfun.isNull(value)) {
          return callback(new Error(this.$t('LanguageLib.LABEL_NAME') + this.$t('LanguageLib.CAN_NOT_BE_EMPTY')))
        } else {
          callback()
        }
      }
    }
    return {
      titleType: this.$t('LanguageLib.LABEL_INFORMATION'),
      ruleForm: {
        SortNo: '',
        TagName: ''
      },
      rules: {
        TagName: [
          { validator: checkTagName, trigger: 'blur' }
        ]
      },
      loadingSave: false // 保存按钮加loding
    }
  },
  beforeRouteEnter (to, from, next) {
    NProgress.configure({
      easing: 'ease',
      speed: 500,
      showSpinner: false,
      trickleSpeed: 200,
      minimum: 0.3
    })
    NProgress.start()
    if (to.query.type === 'edit') {
      basicdataApi.getpersonTagDetail('get', '/tag/getusertag',
        {
          id: to.query.id
        })
        .then(res => {
          NProgress.done()
          next(vm => {
            vm.ruleForm.SortNo = res.data.sortNo === null ? '' : res.data.sortNo
            vm.ruleForm.TagName = res.data.tagName
          })
        })
        .catch(err => {
          this.$commonfun.console.log(err)
        })
    } else {
      NProgress.done()
      next(vm => {
      })
    }
  },
  created () {
    // 获取人员标签序号
    basicdataApi.SortNo('get', '/tag/user/sortNo')
      .then(res => {
        if (this.$route.query.type === 'add') {
          this.ruleForm.SortNo = res.data
        }
      })
      .catch(err => {
        this.$commonfun.console.log(err)
      })
  },
  methods: {
    // 去除组织名称的特殊字符
    btKeyUp (e) {
      e.target.value = e.target.value.replace(/[\\/:：*?？"<>|]/g, '')
    },
    // 返回
    goReturn () {
      this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
    },
    // 保存数据
    submit (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.ruleForm.TagName = this.ruleForm.TagName.replace(/[\\/:：*?？"<>|]/g, '')
          this.loadingSave = true
          if (this.$route.query.type === 'add') {
            basicdataApi.AddPersonData('post', '/tag/CreateUserTag', {
              TagName: this.$commonfun.trim('tail', this.ruleForm.TagName),
              SortNo: this.ruleForm.SortNo === '' ? null : this.ruleForm.SortNo * 1
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.ADDED_SUCCESSFULLY1')
                })
                this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          } else {
            basicdataApi.EditPersonData('post', '/tag/UpdateUsertag', {
              TagName: this.$commonfun.trim('tail', this.ruleForm.TagName),
              SortNo: this.ruleForm.SortNo === '' ? null : this.ruleForm.SortNo * 1,
              id: this.$route.query.id
            })
              .then(res => {
                this.$message({
                  type: 'success',
                  message: this.$t('LanguageLib.EditSuccess')
                })
                this.$router.push('/basicdata/tagmanagement?currentPage=' + this.$route.query.currentPage + '&pageSize=' + this.$route.query.pageSize + '&searchText=' + this.$commonfun.encodeUrl(this.$route.query.searchText) + '&sort=' + this.$route.query.sort + '&isAsc=' + this.$route.query.isAsc + '&currentType=' + this.$route.query.currentType)
                this.loadingSave = false
              })
              .catch(err => {
                this.loadingSave = false
                this.$commonfun.console.log(err)
              })
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="scss">
.AddpersonTag{
  .return{
    padding-left: 25px;
    position: relative;
    height:50px;
    background:rgba(255,255,255,1);
    line-height: 50px;
    border-bottom: 1px solid #F2F2F2;
    .el-icon-back{
      margin-right: 15px;
      cursor: pointer;
    }
    .border{
      position: absolute;
      height: 37px;
      border-left: 1px solid #f1f1f1;
      display: inline-block;
      top: 5px;
    }
    .title{
      height:25px;
      font-size:18px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(0,0,0,1);
      margin-left: 15px;
    }
  }
  .content::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }
  .content::-webkit-scrollbar-thumb {
    border-radius: 5px;
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    background: #E1E1E1;
  }
  .content::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(255,255,255,0.2);
    border-radius: 5px;
    background: #fff;
  }
  .content{
    box-sizing: border-box;
    background:rgba(255,255,255,1);
    width: 100%;
    height: calc( 100% - 50px);
    overflow-y: auto;
    padding-left: 100px;
    padding-top: 15px;
    .drawerText{
      margin-bottom: 5px;
      height:16px;
      font-size:14px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(77,77,77,1);
      line-height:16px;
    }
  }
  // 修改按钮样式
  .el-button--primary{
    background-color: #3BC6B9;
    border-color: #3BC6B9;
    height: 30px;
    padding: 7px 20px;
    margin-bottom: 15px;
  }
  .colorRed{
    color: red;
  }
}
</style>
